import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ValidateDriverDriverInfo } from "./ValidateDriverDriverInfo";

@Injectable()
export class DataService_VppOperatorLookup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	ManualLookup(parms: ValidateDriverDriverInfo) {
		var postResult$ = new Subject();
		var url = "VPP3/ManualLookup";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
